import * as React from 'react'

function SvgComponent(props) {
  return (
    <svg width={100} height={100} viewBox="0 0 100 100" {...props}>
      <g fill="none" fillRule="evenodd">
        <rect
          x={3}
          y={3}
          width={94}
          height={94}
          rx={5}
          strokeWidth={6}
          stroke="#ff6d6d"
        />
        <path d="M32 50h36" strokeWidth={6} stroke="#ff6d6d" />
        <circle fill="#ff6d6d" cx={32} cy={50} r={10} />
        <circle fill="#ff6d6d" cx={68} cy={50} r={10} />
        <path
          d="M50 26v-8m0 64v-8"
          strokeWidth={6}
          stroke="#ff6d6d"
          strokeLinecap="square"
        />
      </g>
    </svg>
  )
}

export default SvgComponent
